<script setup lang="ts">
import { computed } from 'vue';
import VisionCard from '@/components/VisionAi/VisionCard.vue';
import { useVisionModelUpgrade } from '@/components/VisionAi/composables/useVisionModelUpgrade';
import Formatters, { FORMAT_TYPES } from '@dashhudson/dashing-ui/utils/formatters';

const { getUpgradeMessageData, generateVersionNumber } = useVisionModelUpgrade();

const versionInfo = computed(() => generateVersionNumber());

const upgradeMessageData = computed(() =>
  getUpgradeMessageData(versionInfo.value.major, versionInfo.value.minor),
);

const messageIndex = computed(() => upgradeMessageData.value.messageIndex);
const title = computed(() => upgradeMessageData.value.title);
const brandSignals = computed(() =>
  Formatters.formatNumber(upgradeMessageData.value.brandSignals, FORMAT_TYPES.NUMBER),
);
const modelIntegrations = computed(() =>
  Formatters.formatNumber(upgradeMessageData.value.modelIntegrations, FORMAT_TYPES.NUMBER),
);
const brandSpecificDataPoints = computed(() =>
  Formatters.formatNumber(upgradeMessageData.value.brandSpecificDataPoints, FORMAT_TYPES.NUMBER),
);
</script>

<template>
  <VisionCard>
    <div class="text-main-bold">{{ title }}</div>
    <br />
    <div class="text-main">
      <template v-if="messageIndex === 0">
        Updated on over {{ brandSignals }} brand signals, Vision grows sharper with every post,
        every creator, and every ad. <br /><br />
        What’s your next move?
      </template>
      <template v-else-if="messageIndex === 1">
        Trained on thousands of real interactions, Vision understands how your brand moves on
        social. <br /><br />
        What would you like to do next?
      </template>
      <template v-else-if="messageIndex === 2">
        Updated model integrates {{ modelIntegrations }} new brand-specific data points for improved
        contextual analysis. <br /><br />
        How can I help you?
      </template>
      <template v-else-if="messageIndex === 3">
        The latest Vision model is now live, trained on {{ brandSpecificDataPoints }} fresh
        brand-specific data points. Keep posting — Vision learns from every move on social.
      </template>
    </div>
  </VisionCard>
</template>
